<div class="folha">
  <div class="content">
    <h1>BolCó Privacy Policy - v1.01</h1>
    <sub>Last Updated: August 02, 2022</sub>
    <h2>Introduction</h2>
    <p>
      BolCó is the provider of an application of the same name. This policy describes the information we collect during
      your use of the application, how we use it, and how it may be shared.
    </p>
    <h2>Information collected</h2>
    <p>
      BolCó requires several pieces of personal information in order to operate as designed at the logged part of the
      site, this set of information includes a nickname and full name. Some other pieces of personal information are not
      required to use the application but might be provided by the user, this second set of information includes a
      country and genre. BolCó uses provided information only for internal purposes and does not disclose data to third
      parties.
    </p>
    <h2>Analytics</h2>
    <p>
      BolCó uses third-party analytics software to provide us with information regarding the usage of the application.
      The information we receive from such third-party analytics software is not Personal Information attributable to
      any user but rather information that is aggregated by the software so that we can track such things as how many
      users are using the application on a daily, weekly or monthly basis.
    </p>
    <h2>Security</h2>
    <p>
      The security of your personal information is important to us. We follow generally accepted industry standards to
      protect the personal information submitted to us, both during transmission and once we receive it. No method of
      transmission over the Internet, or method of electronic storage, is 100% secure, however. Therefore, we cannot
      guarantee its absolute security.
    </p>
    <h2>User generated content</h2>
    <p>
      BolCó is an application that lets the user compare news from providers using analytics, but no news content are
      available for users
    </p>
    <h2>Advertisement</h2>
    <p>There is no advertisement in the official version of BolCó application.</p>
    <h2>Access to Personal Information</h2>
    <p>
      If your personally identifiable information changes, or if you no longer desire our service, you may correct,
      update, amend, delete/remove or deactivate it by emailing our Customer Support at
      <a href="mailto:bolco@ap1.com.br" class="email">bolco&#64;ap1.com.br</a>.
    </p>
    <h2>Data Retention</h2>
    <p>
      We will retain your information as needed to provide you services. If you wish to request that we no longer use
      your information to provide you services contact us at the email address provided above. We will retain and use
      your information as necessary to comply with our legal obligations, resolve disputes, and enforce our agreements.
    </p>
    <h2>Age Restricted Activities</h2>
    <p>Most of the activities and features of the "BolCó" application are able to be enjoyed by all ages.</p>
    <h2>Contacting the team</h2>
    <p>
      If you have any questions about this privacy statement, you can contact us on
      <a href="mailto:bolco@ap1.com.br" class="email">bolco&#64;ap1.com.br</a>.
    </p>
  </div>
</div>
